import { useState, useEffect, useCallback, RefObject } from "react"
import { useDebouncedCallback } from "../../../../mp-core/hooks"

export const useHasHorizontalScroll = (
  ref: RefObject<HTMLElement>,
  hasDiagonalHeaders: boolean = false
): boolean => {
  const [hasHorizontalScroll, setHasHorizontalScroll] = useState(false)

  const checkScroll = useCallback(() => {
    const element = ref.current
    if (!element) return

    const hasScroll = element.scrollWidth > element.clientWidth
    setHasHorizontalScroll(hasScroll)
  }, [ref])

  const debouncedCheckScroll = useDebouncedCallback(checkScroll, 100)

  useEffect(() => {
    // NOTE: temporary.
    // For now, the header for other tables uses a minimum height of 46px, while the header cells themselves use a height of 38px. The remaining 8 pixels are reserved for the scrollbar.
    if (!hasDiagonalHeaders) {
      setHasHorizontalScroll(false)
      return
    }

    checkScroll()

    const element = ref.current
    if (!element) return

    const resizeObserver = new ResizeObserver(debouncedCheckScroll)
    resizeObserver.observe(element)

    const mutationObserver = new MutationObserver(debouncedCheckScroll)
    mutationObserver.observe(element, {
      childList: true,
      subtree: true
    })

    return () => {
      resizeObserver.disconnect()
      mutationObserver.disconnect()
      debouncedCheckScroll.cancel()
    }
  }, [ref, hasDiagonalHeaders, checkScroll, debouncedCheckScroll])

  return hasHorizontalScroll
}
